//测试
// const tx_header = "";
// const api_header = "http://192.168.31.88:12121/match";
// const address = "http://192.168.3.86:8080";


//内部线上
// const tx_header = "";
// const api_header = "http://system-dev-api.yunicu.com/match";
// const address = "http://system-dev-web.yunicu.com/match";

// 管理后台访问域名：admin.eventpack.cn
// 管理后台接口域名：admin-api.eventpack.cn
// 小程序接口域名：mina-api.eventpack.cn

//正式线上
const tx_header = "";
const api_header = "https://admin-api.eventpack.cn/match";
const address = "https://admin.eventpack.cn";


export default {
  address,
  api_header,
  tx_header,
};
